;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.pennylane')
    .controller('PennylaneCallbackController', PennylaneCallbackController)

  PennylaneCallbackController.$inject = [
    // Angular
    '$location',
    '$state',
    '$stateParams',
    '$window',
    // Libs
    // Managers
    // Services
    'PennylaneService'
    // Const
    // Resolved
  ]

  /**
   * Écran de retour OAuth Pennylane : relaie le `code` (+ `state` anti-CSRF)
   * au backend-pennylane qui l'échange contre les tokens company-scoped.
   * ⚠️ Sécurité : `code` et `state` ne sont JAMAIS loggués ni affichés
   * (ni en succès ni en échec) — ils ne transitent que vers le backend.
   */
  function PennylaneCallbackController (
    // Angular
    $location,
    $state,
    $stateParams,
    $window,
    // Libs
    // Managers
    // Services
    PennylaneService
    // Const
    // Resolved
  ) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public attributes
        // 'loading' → 'success' | 'error'
        status: 'loading',
        errorMessage: '',
        // Public methods
        goToPreferences
      })
      handleCallback()
    }

    /**
     * Lit un paramètre OAuth : `$stateParams` d'abord (nominal — l'app est en
     * html5Mode(true), la query HTTP arrive donc bien dans ui-router), puis
     * repli défensif sur la query string brute du navigateur
     * (`$window.location.search`) au cas où un rewrite/proxy amont aurait
     * altéré la façon dont ui-router voit l'URL.
     */
    function readOAuthParam (name) {
      if ($stateParams[name]) return $stateParams[name]
      const raw = ($window.location.search || '').replace(/^\?/, '')
      let found = null
      raw.split('&').forEach((pair) => {
        const idx = pair.indexOf('=')
        if (idx <= 0) return
        // Un encodage malformé (%xx invalide) ferait lever decodeURIComponent :
        // on ignore la paire plutôt que de casser l'init du controller.
        try {
          const key = decodeURIComponent(pair.slice(0, idx))
          if (key === name && !found) found = decodeURIComponent(pair.slice(idx + 1))
        } catch (e) { /* paire illisible → ignorée */ }
      })
      return found
    }

    /**
     * Retire `code`/`state` de l'URL (replace : pas de nouvelle entrée
     * d'historique) pour ne pas laisser traîner un code OAuth mort dans
     * l'URL/l'historique. Les params du state sont `dynamic` → pas de
     * rechargement du controller.
     */
    function cleanQueryString () {
      $location.search('code', null).search('state', null).replace()
    }

    function fail (message) {
      self.status = 'error'
      self.errorMessage = message
    }

    /** Relaie le code OAuth au backend, qui stocke les tokens de la company. */
    function handleCallback () {
      const code = readOAuthParam('code')
      const state = readOAuthParam('state')
      if (!code || !state) {
        fail('Paramètres de retour Pennylane manquants. Relancez la connexion depuis les préférences.')
        return
      }

      // 1 company par tenant : on résout celle du tenant courant.
      PennylaneService.getCompanies().then((res) => {
        const company = (res && res.data && res.data[0]) || null
        if (!company) {
          fail('Aucune entreprise Pennylane trouvée pour votre compte. Créez et provisionnez votre fiche depuis les préférences.')
          return null
        }
        return PennylaneService.sendCallback(company._id, code, state).then(() => {
          cleanQueryString()
          self.status = 'success'
        })
      }).catch((err) => {
        // Message générique : ne JAMAIS refléter code/state ni le détail brut.
        if (err && err.status === 400) {
          // state anti-CSRF invalide/expiré ou paramètres refusés par le backend.
          fail('La demande de connexion a expiré ou est invalide. Relancez la connexion depuis les préférences.')
        } else {
          fail('La connexion à Pennylane a échoué. Réessayez depuis les préférences ; si le problème persiste, contactez un administrateur.')
        }
      })
    }

    /** Retour vers l'onglet PENNYLANE des préférences (index 9). */
    function goToPreferences () {
      $state.go('preferences', { tabIndex: 9 })
    }
  }
})(window.angular, window._)
